import Vue from 'vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueRouter from 'vue-router'
import store from './store'
Vue.use(Loading);

let pageLoader;

let routes = [
    {
        path: '/account',                                       // all the routes which needs authentication + two factor authentication + lock screen
        component: require('./layouts/default-page').default,
        meta: { validate: ['auth','two_factor','lock_screen'] },
        children: [
           /* {
                path: '/',
                component: require('./views/pages/home').default
            }, */
            {
                path: '/account/dashboard',
                component: require('./views/pages/home').default
            },
            {
                path: '/account/questionnaire',
                component: require('./views/pages/questionnaire').default
            },
            {
                path: '/account/documents',
                component: require('./views/pages/documents').default
            },
            {
                path: '/account/documents-b',
                component: require('./views/pages/documents-b').default
            },
            {
                path: '/account/investor-analysis',
                component: require('./views/pages/investor-analysis').default
            },
            {
                path: '/account/investor-analysis-2',
                component: require('./views/pages/investor-analysis-2').default
            },
            {
                path: '/account/investor-selection',
                component: require('./views/pages/investor-selection').default
            },
            {
                path: '/account/pipeline',
                component: require('./views/pages/pipeline').default
            },
            {
                path: '/account/investor-profile/:id',
                component: require('./views/pages/investor-profile').default
            },
            {
                path: '/account/pipeline-test',
                component: require('./views/pages/pipeline-test').default
            },
            {
                path: '/account/pipeline-test-2',
                component: require('./views/pages/pipeline-test-2').default
            },
            {
                path: '/account/calendar',
                component: require('./views/pages/calendar').default
            },
            {
                path: '/account/help/settings',
                component: require('./views/pages/settings').default
            },
            {
                path: '/account/help/support',
                component: require('./views/pages/support').default
            },
            {
                path: '/account/help/message',
                component: require('./views/pages/message').default
            },
            /*
          {
              path: '/mm/:alias',
              component: require('./views/pages/meeting-minutes').default
          },
        {
              path: '/profile',
              component: require('./views/pages/profile').default
          },
          {
              path: '/change-password',
              component: require('./views/pages/change-password').default
          },
          {
              path: '/blank',
              component: require('./views/pages/blank').default
          },
          {
              path: '/configuration',
              component: require('./views/configuration/basic/index').default,
              meta: { menu: 'configuration'}
          },
          {
              path: '/configuration/logo',
              component: require('./views/configuration/logo/index').default,
              meta: { menu: 'configuration'}
          },
          {
              path: '/configuration/mail',
              component: require('./views/configuration/mail/index').default,
              meta: { menu: 'configuration'}
          },
          {
              path: '/backup',
              component: require('./views/backup/index').default
          },
          {
              path: '/configuration/basic',
              component: require('./views/configuration/basic/index').default,
              meta: { menu: 'configuration'}
          },
          {
              path: '/configuration/system',
              component: require('./views/configuration/system/index').default,
              meta: { menu: 'configuration'}
          },
          {
              path: '/configuration/role',
              component: require('./views/configuration/role/index').default,
              meta: { menu: 'configuration'}
          },
          {
              path: '/configuration/menu',
              component: require('./views/configuration/menu/index').default,
              meta: { menu: 'configuration'}
          },*/
            {
                path: '/configuration/authentication',
                component: require('./views/configuration/authentication/index').default,
                meta: { menu: 'configuration'}
            },
          {
                path: '/configuration/permission',
                component: require('./views/configuration/permission/index').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/configuration/permission/assign',
                component: require('./views/configuration/permission/assign').default,
                meta: { menu: 'configuration'}
            },
            /*// {
            //     path: '/configuration/sms',
            //     component: require('./views/configuration/sms/index').default,
            //     meta: { menu: 'configuration'}
            // },
            {
                path: '/configuration/scheduled-job',
                component: require('./views/configuration/scheduled-job/index').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/configuration/ip-filter',
                component: require('./views/configuration/ip-filter/index').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/configuration/ip-filter/:id/edit',
                component: require('./views/configuration/ip-filter/edit').default,
                meta: { menu: 'configuration'}
            },

            {
                path: '/configuration/locale',
                component: require('./views/configuration/locale/index').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/configuration/locale/:id/edit',
                component: require('./views/configuration/locale/edit').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/configuration/locale/:locale',
                component: require('./views/configuration/locale/view').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/configuration/locale/:locale/:module',
                component: require('./views/configuration/locale/view').default,
                meta: { menu: 'configuration'}
            },

            {
                path: '/email-log',
                component: require('./views/email-log/index').default
            }, */
            {
                path: '/configuration/role',
                component: require('./views/configuration/role/index').default,
                meta: { menu: 'configuration'}
            },

            {
                path: '/account/email-template',
                component: require('./views/email-template/index').default
            },
            {
                path: '/account/email-template/:id/edit',
                component: require('./views/email-template/edit').default
            },

            {
                path: '/account/activity-log',
                component: require('./views/activity-log/index').default
            },
          /*  {
                path: '/todo',
                component: require('./views/todo/index').default
            },
            {
                path: '/todo/:id/edit',
                component: require('./views/todo/edit').default
            },
            {
                path: '/objects',
                component: require('./views/object/index').default
            },
            {
                path: '/objects/:id/edit',
                component: require('./views/object/edit').default
            },*/
            {
                path: '/account/transcripts',
                component: require('./views/transcript/index').default
            },
            {
                path: '/account/transcripts/test',
                component: require('./views/transcript/test').default
            },
            {
                path: '/account/transcripts/bio-test',
                component: require('./views/transcript/bio-test').default
            },
            {
                path: '/account/transcripts/:id/meeting-minutes',
                component: require('./views/transcript/meeting-minutes').default
            },
            {
                path: '/account/transcripts/:id',
                component: require('./views/transcript/basic').default
            },
            {
                path: '/account/ai-features/recommender',
                component: require('./views/ai-features/recommender').default
            },
            {
                path: '/account/ai-features/data-notes',
                component: require('./views/ai-features/data-notes').default
            },
            {
                path: '/account/ai-features/email-data',
                component: require('./views/ai-features/email-data').default
            },
            {
                path: '/account/ai-features/marketing-docs',
                component: require('./views/ai-features/marketing-docs').default
            },
            {
                path: '/account/investors',
                // component: require('./views/user/index').default
                component: require('./views/investor').default
            },
            {
                path: '/account/investor-callcenter',
                component: require('./views/investor/investor-callcenter').default
            },
            {
                path: '/account/investor-contacts',
                // component: require('./views/user/index').default
                component: require('./views/investor/contacts').default
            },
            {
                path: '/account/investor-contacts/:id',
                // component: require('./views/user/index').default
                component: require('./views/investor/contacts-basic').default
            },
            {
                path: '/account/investor-contacts/:id/basic',
                // component: require('./views/user/index').default
                component: require('./views/investor/contacts-basic').default
            },
            {
                path: '/account/deals',
                // component: require('./views/user/index').default
                component: require('./views/deal').default
            },
            {
                path: '/account/deals/:id',
                // component: require('./views/user/index').default
                component: require('./views/deal/pipeline').default
            },
            {
                path: '/account/investors/:id',
                // component: require('./views/user/index').default
                component: require('./views/investor/basic').default
            },
            {
                path: '/account/investors/:id/basic',
                // component: require('./views/user/index').default
                component: require('./views/investor/basic').default
            },
            {
                path: '/account/investors/:id/data-matching',
                // component: require('./views/user/index').default
                component: require('./views/investor/data-matching').default
            },
            {
                path: '/account/investors/:id/notes',
                component: require('./views/investor/notes').default
            },
            {
                path: '/account/investors/:id/contacts',
                component: require('./views/investor/investor-contacts').default
            },
            {
                path: '/account/investors/:id/contacts/:cid',
                component: require('./views/investor/investor-contact-basic').default
            },
            {
                path: '/account/investors/:id/emails-pipeline',
                component: require('./views/investor/emails-pipeline').default
            },
            {
                path: '/account/user',
                // component: require('./views/user/index').default
                redirect: '/account/users/general-partners',
            },
            {
                path: '/account/users/administrators',
                component: require('./views/user/administrator').default
            },
            {
                path: '/account/users/general-partners',
                component: require('./views/user/general-partner').default
            },
            {
                path: '/account/users/general-partners/:id/fact-sheet',
                component: require('./views/user/fact-sheet').default
            },
            {
                path: '/account/users/general-partners/:id/fact-sheet-v2',
                component: require('./views/user/fact-sheet-v2').default
            },
            {
                path: '/account/users/general-partners/:id/profile',
                component: require('./views/user/profile').default
            },
            {
                path: '/account/investors/:id/profile',
                component: require('./views/investor/profile').default
            },
            {
                path: '/account/investors/:id/profile/:deal_id',
                component: require('./views/investor/profile').default
            },
            {
                path: '/account/users/general-partners/:id/investors',
                component: require('./views/user/investors').default
            },
            {
                path: '/account/users/general-partners/:id/weightings',
                component: require('./views/user/weightings-general-partner').default
            },
            {
                path: '/account/users/general-partners/:id/sales-pipeline',
                component: require('./views/user/sales-pipeline-general-partner').default
            },
            {
                path: '/account/users/general-partners/:id/login-log',
                component: require('./views/user/login-log-general-partner').default
            },
            {
                path: '/account/users/general-partners/:id/campaign',
                component: require('./views/user/campaign').default
            },
            {
                path: '/account/users/administrators/:id',
                component: require('./views/user/basic-administrator').default
            },
            {
                path: '/account/users/general-partners/:id',
                component: require('./views/user/basic-general-partner').default
            },
            {
                path: '/account/users/general-partners/:id/basic',
                component: require('./views/user/basic-general-partner').default
            },
            {
                path: '/account/users/general-partners/:id/contact',
                component: require('./views/user/contact-general-partner').default
            },
            {
                path: '/account/users/general-partners/:id/password',
                component: require('./views/user/password-general-partner').default
            },
            {
                path: '/account/user/:id',
                component: require('./views/user/basic').default
            },
            {
                path: '/account/user/:id/basic',
                component: require('./views/user/basic').default
            },
            {
                path: '/account/user/:id/investors',
                component: require('./views/user/user_investors').default
            },
            {
                path: '/account/user/:id/investor-list',
                component: require('./views/user/user_investorlist').default
            },
            {
                path: '/account/user/:id/questionnaire',
                component: require('./views/user/questionnaire').default
            },
            {
                path: '/account/user/:id/documents',
                component: require('./views/user/documents').default
            },
            {
                path: '/account/user/:id/notes',
                component: require('./views/user/user_notes').default
            },
            {
                path: '/account/user/:id/emails-pipeline',
                component: require('./views/user/emails-pipeline-general-partner').default
            },
            {
                path: '/account/user/:id/contact',
                component: require('./views/user/contact').default
            },
            {
                path: '/account/user/:id/avatar',
                component: require('./views/user/avatar').default
            },
          /*  {
                path: '/user/:id/social',
                component: require('./views/user/social').default
            }, */
            {
                path: '/account/user/:id/password',
                component: require('./views/user/password').default
            },
            {
                path: '/account/user/:id/email',
                component: require('./views/user/email').default
            },
          /*  {
                path: '/message',
                component: require('./views/message/index').default
            },
            {
                path: '/message/compose',
                component: require('./views/message/index').default
            },
            {
                path: '/message/inbox',
                component: require('./views/message/inbox').default
            },
            {
                path: '/message/sent',
                component: require('./views/message/sent').default
            },
            {
                path: '/message/important',
                component: require('./views/message/important').default
            },
            {
                path: '/message/trash',
                component: require('./views/message/trash').default
            },
            {
                path: '/message/draft',
                component: require('./views/message/draft').default
            },
            {
                path: '/message/:uuid/draft',
                component: require('./views/message/edit-draft').default
            },
            {
                path: '/message/:uuid',
                component: require('./views/message/view').default
            }, */
        ]
    },
    {
        path: '/',
        component: require('./layouts/guest-page').default,
        meta: { validate: ['auth'] },
        children: [
            {
                path: '/auth/security',
                component: require('./views/auth/security').default,
            },
            {
                path: '/auth/lock',
                component: require('./views/auth/lock').default,
            },
        ]
    },
    {
        path: '/',                      // all the routes which can be access without authentication
        component: require('./layouts/guest-page').default,
        meta: { validate: ['guest'] },
        children: [
           /* {
                path: '/',
                component: require('./views/auth/login').default
            }, */
            {
                path: '/mm/:alias',
                component: require('./views/pages/meeting-minutes').default
            },
            {
                path: '/fs/:alias/share',
                component: require('./views/pages/fact-sheet').default
            },
            {
                path: '/fs2/:alias/share',
                component: require('./views/pages/fact-sheet-v2').default
            },
            {
                path: '/mm-test/:alias',
                component: require('./views/pages/meeting-minutes-2').default
            },
            {
                path: '/login',
                component: require('./views/auth/login').default
            },
            {
                path: '/login-social',
                component: require('./views/auth/login-social').default
            },
            {
                path: '/password',
                component: require('./views/auth/password').default
            },
            {
                path: '/register',
                component: require('./views/auth/register').default
            },
            {
                path: '/sign-up',
                component: require('./views/auth/signup').default
            },
            {
                path: '/introduction',
                component: require('./views/auth/signup').default
            },
            {
                path: '/auth/:token/activate',
                component: require('./views/auth/activate').default
            },
            {
                path: '/password/reset/:token',
                component: require('./views/auth/reset').default
            },
            {
                path: '/auth/social',
                component: require('./views/auth/social-auth').default
            }
        ]
    },
    {
        path: '/',
        component : require('./layouts/guest-page').default,
        children: [
            {
                path: '/terms-and-conditions',
                component: require('./views/pages/terms-and-conditions').default
            }
        ]
    },
    {
        path: '/',
        component : require('./layouts/error-page').default,
        children: [
            {
                path: '/terms-and-conditions',
                component: require('./views/pages/terms-and-conditions').default
            },
            {
                path: '/ip-restricted',
                component: require('./views/errors/ip-restricted').default
            },
            {
                path: '/maintenance',
                component: require('./views/errors/maintenance').default
            }
        ]
    },
    {
        path: '*',
        component : require('./layouts/error-page').default,
        children: [
            {
                path: '*',
                component: require('./views/errors/page-not-found').default
            }
        ]
    }
];

const router = new VueRouter({
    routes,
    // linkActiveClass: 'active',
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
});

router.beforeEach((to, from, next) => {
    pageLoader = Vue.$loading.show();
    // For force logout
    // store.dispatch('resetAuthUserDetail');

    helper.check()
        .then(response => {

            // Initialize toastr notification
            helper.notification();

            // Check for IP Restriction; If restricted IP found, redirect to "/ip-restricted" route
            if(helper.getConfig('ip_filter') && localStorage.getItem('ip_restricted') && to.fullPath != '/ip-restricted') {
                pageLoader.hide();
                return next({ path: '/ip-restricted' })
            }

            // Check for Maintenance mode; If maintenance mode is on, redirect to "/maintenance" route
            if(helper.isAuth() && !helper.hasRole('admin') && helper.getConfig('maintenance_mode') && to.fullPath != '/maintenance') {
                pageLoader.hide();
                return next({ path: '/maintenance' })
            }

            if (to.matched.some(m => m.meta.validate)){
                const m = to.matched.find(m => m.meta.validate);

                // Check for authentication; If no, redirect to "/login" route
                if (m.meta.validate.indexOf('auth') > -1){
                    if(!helper.isAuth()){
                        toastr.error(i18n.auth.auth_required);
                        pageLoader.hide();
                        return next({ path: '/login' })
                    }
                }

                // Check for two factor security; If enabled, redirect to "/auth/security" route after login
                if (m.meta.validate.indexOf('two_factor') > -1){
                    if(helper.getConfig('two_factor_security') && helper.getTwoFactorCode()){
                        pageLoader.hide();
                        return next({ path: '/auth/security' })
                    }
                }

                // Check for screen lock; If enabled, redirect to "/auth/lock" route after screen lock timeout
                if (m.meta.validate.indexOf('lock_screen') > -1){
                    if(helper.getConfig('lock_screen') && helper.isScreenLocked()){
                        pageLoader.hide();
                        return next({ path: '/auth/lock' })
                    }
                }

                if(!store.getters.getAuthUser('fund_type_id') && to.fullPath != '/account/questionnaire' && helper.isAuth()){
                    pageLoader.hide();
                    return next({ path: '/account/questionnaire' })
                }

                // Check for authentication; If authenticated, redirect to "/home" route

               // console.log("lof:"+window.location.href);

                if (m.meta.validate.indexOf('guest') > -1 && window.location.href.indexOf('/mm') == -1 && window.location.href.indexOf('/fs') == -1){
                    if(helper.isAuth()){
                        toastr.error(i18n.auth.guest_required);
                        pageLoader.hide();
                        if(helper.hasRole('admin') || helper.hasRole('sales') || helper.hasRole('tester')) {
                            return next({path: '/account/users/general-partners'})
                        }else if(helper.hasRole('callcenter')) {
                            return next({path: '/account/investor-callcenter'})
                        }else if(helper.hasRole('editor')) {
                            return next({path: '/account/investors'})
                        }else{
                            return next({path: '/account/dashboard'})
                        }
                    }
                }
            }

        return next()
    })
    .catch(error => {
        // Authentication check fail, redirected back to "/login" route
        store.dispatch('resetAuthUserDetail');
        pageLoader.hide();
        return next({ path: '/login' })
    });
});

router.afterEach((to, from) => {
    pageLoader.hide();
});

export default router;
